// extracted by mini-css-extract-plugin
module.exports = {"Card":"PackOrEntraceSummaryCard_Card__3_nvW","Title":"PackOrEntraceSummaryCard_Title__1Y6Wn","SubTotal":"PackOrEntraceSummaryCard_SubTotal__1sgmH"};